import { defer, type LoaderFunctionArgs } from 'react-router-dom'

import { salesTaxService } from '$services'
import { logger } from '$utils'

import useMenusStore from '../store'
import { isAppStateReady } from 'src/state/store'

async function viewMenuLoader({ params }: LoaderFunctionArgs) {
  logger.debug(
    '[loader] About to await AppState being ready in ViewMenu loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in ViewMenu loader')

  const { menuId } = params

  if (!menuId) {
    throw new Error('Menu ID is required')
  }

  const menusStore = useMenusStore.getState()
  const menuPromise = menusStore.getMenu(menuId)
  const salesTaxPromise = salesTaxService.getAllSalesTaxRates()
  const recipesPromise = menusStore.getRecipes()
  const itemsPromise = menusStore.getItems()

  return defer({
    data: Promise.all([
      menuPromise,
      salesTaxPromise,
      recipesPromise,
      itemsPromise,
    ]).then(([_, salesTaxRates, recipes, items]) => ({
      salesTaxRates,
      recipes,
      items,
    })),
  })
}

export default viewMenuLoader
